module.exports = __webpack_public_path__ + "img/resource-tech-image-35.a03a08c2.jpg";